<template>
  <div class="tab-bar">
    <router-link to="/home" class="tab-item" active-class="active">
      <svg-icon
        icon-name="首页"
        :is-active="['/home', '/spring-festival', '/9th-anniversary'].includes($route.path)"
      />
      <span>首页</span>
    </router-link>
    <router-link to="/category" class="tab-item" active-class="active">
      <svg-icon
        icon-name="分类"
        :is-active="
          ['/category', '/feature-zone', '/category-detail'].includes(
            $route.path
          )
        "
      />
      <span>分类</span>
    </router-link>
    <a
      href="https://m.gdtvdv.com/wap/ShoppingCart/#!/home"
      class="tab-item"
      target="_self"
    >
      <svg-icon icon-name="购物" :is-active="false" />
      <span>购物车</span>
    </a>
    <a
      href="https://m.gdtvdv.com/wap/shop/MemberDefault.aspx"
      class="tab-item"
      target="_self"
    >
      <svg-icon icon-name="我的" :is-active="false" />
      <span>我的</span>
    </a>
    <!-- 使用新组件 -->
    <!-- <router-link to="/my-center" class="tab-item" active-class="active"> -->
      <!-- <a
        href="https://m.gdtvdv.com/wap/shop/mbn2.aspx"
        class="tab-item"
        target="_self"
      > -->
        <!-- <svg-icon
          icon-name="我的"
          :is-active="
            [
              '/my-center',
              '/coupon-list',
              '/score-list',
              '/order-list',
              '/order-detail',
              '/address-list',
              '/logistics-detail',
            ].some((path) => $route.path.startsWith(path))
          "
        />
        <span>我的</span>   -->
      <!-- </a> -->
    <!-- </router-link> -->
  </div>
</template>

<script>
import SvgIcon from "./SvgIcon.vue";

export default {
  name: "TabBar",
  components: {
    SvgIcon,
  },
};
</script>

<style lang="scss" scoped>
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  /* 基础高度 + 底部安全区域 */
  height: calc(50px + env(safe-area-inset-bottom));
  /* 只添加内边距，让内容区域被压缩 */
  /* height: 50px; */
  /* padding-bottom: env(safe-area-inset-bottom); */

  /* 应用底部安全区域内边距 */
  padding-bottom: env(safe-area-inset-bottom);
  background: #fff;
  display: flex;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.1);
  z-index: 100;
  box-sizing: border-box; /* 确保 padding 被包含在 height 计算内 */
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 如果只增加了 padding 而不是 height, 可能需要 justify-content: flex-start 并给图标/文字加 margin-top */
  justify-content: center; /* 保持垂直居中 */
  color: #666;
  text-decoration: none;
  font-size: 12px;
  /* 增加一点顶部内边距，让内容在增加高度后看起来更居中 */
  /* padding-top: 2px;  */
  /* 注意：如果感觉内容偏上，可以取消注释上面这行 */

  .svg-icon {
    width: 24px;
    height: 24px;
    margin-bottom: 2px;
  }

  span {
    margin-top: 2px;
  }

  &.active {
    color: #ff6b6b;
  }

  &.disabled {
    color: #ccc;
    pointer-events: none;
  }
}
</style>
